'use strict';

var _AvaTaxClient = require('./lib/AvaTaxClient');

var _AvaTaxClient2 = _interopRequireDefault(_AvaTaxClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _AvaTaxClient2.default; /**
                                          * Avalara © 2017
                                          * file: index.js
                                          */



//////////////////
// WEBPACK FOOTER
// ./node_modules/avatax/index.js
// module id = 128
// module chunks = 0